module.exports = __webpack_public_path__ + "202408221624/img/animation_haixiu.3d5c6a83.png";